import {
  MarkerProps as BaseMarkerProps,
  Marker as BaseMarker,
  InfoWindow,
} from "@react-google-maps/api";
import { DEFAULT_MAP_MARKER_COLOR } from "../../../constants/map";

export type MarkerProps = BaseMarkerProps & {
  iconColor?: string;
  iconSize?: number;
  isHovered?: boolean;
  iconUrl?: string;
};

const Marker = (
  props: MarkerProps
) => {
  const {
    iconColor = DEFAULT_MAP_MARKER_COLOR,
    isHovered = false,
    children,
    iconUrl,
    iconSize = 20,
    ...otherProps
  } = props;

  const { position } = props;

  return (
    <>
      {/* Hide the close button with css as there is no option provided to do so  */}
      <style>
        {`
          .gm-style-iw-chr {
            display: none;
          }
        `}
      </style>

      <BaseMarker
        icon={{
          // Icon taken from https://tabler.io/icons
          url: iconUrl
            ? iconUrl
            : `data:image/svg+xml;charset=UTF-8,<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="${encodeURIComponent(
                iconColor || DEFAULT_MAP_MARKER_COLOR
              )}"  class="icon icon-tabler icons-tabler-filled icon-tabler-map-pin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z" /></svg>`,
          ...(window?.google?.maps?.Size && {
            scaledSize: new (window.google.maps.Size)(iconSize, iconSize),
          }),
        }}
        {...otherProps}
      >
        {isHovered && (
          <InfoWindow
            position={position} // Ensure position prop is correctly passed
            options={{
              ...(window?.google?.maps?.Size && {
                pixelOffset: new (window.google.maps.Size)(0, -30),
              }),
              disableAutoPan: true,
            }}
          >
            <div className="pt-[12px]">{children}</div>
          </InfoWindow>
        )}
      </BaseMarker>
    </>
  );
};

export default Marker;
